import { FC } from 'react'

import { FF, FormType, RadioGroup, Select, TextareaInput } from 'ui/components'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { QuestionnaireDemo } from '../../../../../../types'
import * as SC from '../../../../style'

export const ConsumerAccount: FC<{ formApi: FormType<QuestionnaireDemo> }> = ({ formApi }) => {
  return (
    <>
      <FormRow>
        <Col>
          <SC.SecondText>Does the business owner(s)/account signer(s) have a consumer account?</SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="consumerAccountHave"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name="consumerAccountPurpose"
            children={(field) => (
              <FF
                field={field}
                label="Purpose of transfer(s) for consumer account?"
                input={(p) => (
                  <Select
                    data={[
                      {
                        label: 'No Transactions of This Type',
                        value: 'no_transactions'
                      },
                      {
                        label: 'Transfer for Tax Purposes',
                        value: 'tax_purposes'
                      },
                      {
                        label: 'Transfer for Loan Payment',
                        value: 'loan_payment'
                      },
                      {
                        label: 'Transfer for Contribution/Distribution',
                        value: 'contribution_distribution'
                      },
                      {
                        label: 'Unsure of Transfer Purpose – See Quarterly and/or Annual Review Questions',
                        value: 'see_quarterly'
                      },
                      {
                        label: 'Other – See Comments',
                        value: 'other'
                      }
                    ]}
                    {...p}
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="consumerAccountComments"
            children={(field) => (
              <FF field={field} label="Comments" input={(p) => <TextareaInput maxLength={5000} {...p} />} />
            )}
          />
        </Col2x>
      </FormRow>
    </>
  )
}
